// extracted by mini-css-extract-plugin
export default {"vouchers":"Voucher_vouchers__ocJ3r","title":"Voucher_title__vZOUP","errorVouchers":"Voucher_errorVouchers__samBU"};